function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useRef, useCallback } from 'react';
import classNames from 'classnames';
import { Tooltip } from '@deephaven/components';
import { Plot, useChartTheme } from '@deephaven/chart';
import Log from '@deephaven/log';
import { useAsyncInterval, useIsMountedRef } from '@deephaven/react-hooks';
import "./HeapUsage.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('HeapUsage');
function HeapUsage(_ref) {
  var _timestamps2;
  var connection = _ref.connection,
    defaultUpdateInterval = _ref.defaultUpdateInterval,
    hoverUpdateInterval = _ref.hoverUpdateInterval,
    _ref$bgMonitoring = _ref.bgMonitoring,
    bgMonitoring = _ref$bgMonitoring === void 0 ? true : _ref$bgMonitoring,
    monitorDuration = _ref.monitorDuration;
  var chartTheme = useChartTheme();
  var _useState = useState({
      freeMemory: 0,
      maximumHeapSize: 999,
      totalHeapSize: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    memoryUsage = _useState2[0],
    setMemoryUsage = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var historyUsage = useRef({
    timestamps: [],
    usages: []
  });
  var isMountedRef = useIsMountedRef();
  var setUsageUpdateInterval = useCallback(/*#__PURE__*/_asyncToGenerator(function* () {
    try {
      var newUsage = yield connection.getWorkerHeapInfo();
      if (!isMountedRef.current) {
        return;
      }
      setMemoryUsage(newUsage);
      if (bgMonitoring || isOpen) {
        var currentUsage = (newUsage.totalHeapSize - newUsage.freeMemory) / newUsage.maximumHeapSize;
        var currentTime = Date.now();
        var _historyUsage$current = historyUsage.current,
          _timestamps = _historyUsage$current.timestamps,
          _usages = _historyUsage$current.usages;
        while (_timestamps.length !== 0 && currentTime - _timestamps[0] > monitorDuration * 1.5) {
          _timestamps.shift();
          _usages.shift();
        }
        _timestamps.push(currentTime);
        _usages.push(currentUsage);
      } else {
        historyUsage.current = {
          timestamps: [],
          usages: []
        };
      }
    } catch (e) {
      log.warn('Unable to get heap usage', e);
    }
  }), [connection, isMountedRef, bgMonitoring, isOpen, monitorDuration]);
  useAsyncInterval(setUsageUpdateInterval, isOpen ? hoverUpdateInterval : defaultUpdateInterval);
  var toDecimalPlace = (num, dec) => Math.round(num * 10 ** dec) / 10 ** dec;
  var decimalPlace = 2;
  var GbToByte = 1024 ** 3;
  var freeMemory = memoryUsage.freeMemory,
    totalHeapSize = memoryUsage.totalHeapSize,
    maximumHeapSize = memoryUsage.maximumHeapSize;
  var freeMemoryGB = toDecimalPlace(freeMemory / GbToByte, decimalPlace);
  var totalHeapGB = toDecimalPlace(totalHeapSize / GbToByte, decimalPlace);
  var maxHeapGB = toDecimalPlace(maximumHeapSize / GbToByte, decimalPlace);
  var inUseGB = totalHeapGB - freeMemoryGB;
  var getRow = function getRow(text, size) {
    var bottomBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return /*#__PURE__*/_jsxs("div", {
      className: classNames("heap-usage-info-row", {
        'heading-bottom-border': bottomBorder
      }),
      children: [/*#__PURE__*/_jsx("div", {
        className: "font-weight-bold",
        children: text
      }), /*#__PURE__*/_jsx("div", {
        children: size
      })]
    });
  };
  var _historyUsage$current2 = historyUsage.current,
    timestamps = _historyUsage$current2.timestamps,
    usages = _historyUsage$current2.usages;
  var lastTimestamp = (_timestamps2 = timestamps[timestamps.length - 1]) !== null && _timestamps2 !== void 0 ? _timestamps2 : 0;
  var totalPercentage = totalHeapSize / maximumHeapSize;
  var usedPercentage = (totalHeapSize - freeMemory) / maximumHeapSize;
  return /*#__PURE__*/_jsxs("div", {
    className: "max-memory",
    children: [/*#__PURE__*/_jsx("div", {
      className: "total-memory",
      style: {
        width: "calc(".concat(totalPercentage * 100, "% - ").concat(totalPercentage * 2, "px")
      }
    }), /*#__PURE__*/_jsx("div", {
      className: classNames('used-memory', {
        'heap-overflow': (totalHeapSize - freeMemory) / maximumHeapSize > 0.95
      }),
      style: {
        width: "calc(".concat(usedPercentage * 100, "% - ").concat(usedPercentage * 2, "px")
      }
    }), /*#__PURE__*/_jsxs("div", {
      className: "memory-text",
      children: [maxHeapGB.toFixed(1), " GB"]
    }), /*#__PURE__*/_jsx(Tooltip, {
      onEntered: () => setIsOpen(true),
      onExited: () => setIsOpen(false),
      interactive: true,
      children: /*#__PURE__*/_jsxs("div", {
        className: "heap-tooltip",
        children: [getRow('In use:', "".concat(inUseGB.toFixed(decimalPlace), " of ").concat(maxHeapGB.toFixed(decimalPlace), " GB"), true), getRow('Free:', "".concat(freeMemoryGB.toFixed(decimalPlace), " GB")), getRow('Total:', "".concat(totalHeapGB.toFixed(decimalPlace), " GB")), getRow('Max:', "".concat(maxHeapGB.toFixed(decimalPlace), " GB")), /*#__PURE__*/_jsx("div", {
          className: "heap-plot",
          children: /*#__PURE__*/_jsx(Plot, {
            data: [{
              x: [...timestamps],
              y: [...usages],
              type: 'scatter',
              mode: 'lines'
            }],
            config: {
              staticPlot: true,
              responsive: true
            },
            style: {
              width: '196px',
              height: '100px'
            },
            layout: {
              margin: {
                l: 2,
                t: 2,
                r: 2,
                b: 2
              },
              plot_bgcolor: 'transparent',
              paper_bgcolor: 'transparent',
              colorway: ['#4878ea'],
              xaxis: {
                dtick: Math.round(monitorDuration / 6),
                gridcolor: chartTheme.linecolor,
                range: [lastTimestamp - monitorDuration, lastTimestamp],
                linecolor: chartTheme.linecolor,
                linewidth: 2,
                mirror: true
              },
              yaxis: {
                dtick: 0.2,
                gridcolor: chartTheme.linecolor,
                range: [0, 1],
                linecolor: chartTheme.linecolor,
                linewidth: 2,
                mirror: true
              }
            }
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "heap-utilisation-text",
          children: ["% utilization over ", Math.round(monitorDuration / 1000 / 60), " min."]
        })]
      })
    })]
  });
}
export default HeapUsage;
//# sourceMappingURL=HeapUsage.js.map